import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Mustache from 'mustache';
import I18nUtil from '@didi/i18n-util';
const { getLanguage } = I18nUtil;

import { i18nInit, i18nGet } from '@didi/i18n-plugin';
i18nInit(require('./i18n-info'));

import zhCN from './zh-CN';
import enUS from './en-US';
import ptBR from './pt-BR';
import esMX from './es-MX';
import es419 from './es-419';
import { DEFAULT_NAVIGATOR_LOCAL } from '@/config/constants';

Vue.use(VueI18n);

const lang = getLanguage().long;
class CustomFormatter {
  interpolate(message, values) {
    // 觉得Mustache太重，可以实现一个简版
    return Mustache.render(message, values);
  }
}

let instance
const initI18n = () => {
  if (instance) return instance
  instance = new VueI18n({
    locale: lang, // 设置地区
    fallbackLocale: DEFAULT_NAVIGATOR_LOCAL, // 设置默认语言
    formatter: new CustomFormatter(), // 适配I18N翻译平台占位符 {{variable}}
    messages: {
      'en-US': i18nGet(enUS, 'en-us'),
      'zh-CN': i18nGet(zhCN, 'zh-cn'),
      'pt-BR': i18nGet(ptBR, 'pt-br'),
      'es-MX': i18nGet(esMX, 'es-mx'),
      'es-419': i18nGet(es419, 'es-419'),
    },
  })
  return instance
}
instance = initI18n()

const updateI18nLocale = (locale) => {
  // 支持自定义设置locale
  instance.locale = locale ? locale : DEFAULT_NAVIGATOR_LOCAL
}

export {
  initI18n,
  updateI18nLocale,
  instance as default
}
